const SendToMail = () => {
  return (
    <div className="feedbackwrap card-wrap h-auto">
      <div className="card">
        <h2>Send Mail</h2>
        <p>
          Summarize your query briefly and send it to the chosen recipient. You
          can expect a reply within 24 hours.
        </p>

        <div className="emailform mt-3">
          <div className="label-to">
            <label htmlFor="">From</label>
            <div className="stude-details">
              <div className="img">
                <img src="/assets/images/profile06.jpg" alt="" />
              </div>
              <div className="desc">
                <h6>William Sonoma</h6>
                <p>
                  Departement of Science | <span>Imperial College</span>
                </p>
              </div>
            </div>
          </div>
          <div className="multiselect-plugin label-to">
            <label htmlFor="" style={{ height: "44px" }}>
              To
            </label>
            <div id="htmlselect"></div>
          </div>
          <div className="formgroup">
            <label htmlFor="">Subject</label>
            <input type="text" />
          </div>
          <div className="formgroup">
            <label htmlFor="">Message</label>
            <textarea name="" id=""></textarea>
          </div>
        </div>

        <div className="btn-flex mt-3">
          <button type="button" className="btn btn-primary">
            Send
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default SendToMail;
